<template>
  <div style="margin-top: 1%; padding-bottom: 2%">
    Dear A. Jones,<br /><br />
    Since the head office has made it clear that it cannot send any new
    employees to our department at the moment, I am all the more pleased to be
    able to inform you that the the interview with Mr. McKaegan went very well!
    In the conversation, the question also came up when he would want to start
    with us. From his point of view, he could start right away tomorrow, but I
    told him that I am still unsure, because the office furniture that we
    ordered has not arrived yet. <br /><br />
    Many greetings<br />
    Anand Amin
  </div>
</template>

<script>
import "./styles.css";

export default {
  props: {
    parentFunction: Function,
  },
};
</script>
